import type { ReactNode } from 'react';

export const symbol_sports_baseball: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M215-264q51-37 79-95t28-121q0-63-28-121.5T215-697q-38 46-56.5 101.5T140-480q0 60 18.5 115T215-264Zm383.5 104.5Q655-179 703-220q-59-48-91.5-116.5T579-480q0-75 32.5-144T703-741q-48-40-104.5-59.5T480-820q-62 0-118.5 19.5T257-741q59 48 92 117t33 144q0 75-33 143.5T257-220q48 41 104.5 60.5T480-140q62 0 118.5-19.5ZM746-264q38-46 56-101t18-115q0-60-18-115.5T746-697q-51 37-79 95.5T639-480q0 63 28 121t79 95ZM480-480ZM325-111.5q-73-31.5-127.5-86t-86-127.5Q80-398 80-480.5t31.5-155q31.5-72.5 86-127t127.5-86Q398-880 480.5-880t155 31.5q72.5 31.5 127 86t86 127Q880-563 880-480.5T848.5-325q-31.5 73-86 127.5t-127 86Q563-80 480.5-80T325-111.5Z"
		/>
	</svg>
);
